// Puzzle extra words: valid words the player spelled that were not part of
// the solution. The Worker refuses them without recording anything, so the
// game keeps them per play in this browser for the Completion tab's stats.
const key = (playId: string) => `wits.extraWords.${playId}`;

export function loadExtraWords(playId: string): string[] {
  try {
    const raw = localStorage.getItem(key(playId));
    const words = raw ? (JSON.parse(raw) as unknown) : [];
    return Array.isArray(words) ? words.filter((w): w is string => typeof w === 'string') : [];
  } catch {
    return [];
  }
}

export function saveExtraWords(playId: string, words: readonly string[]): void {
  try {
    localStorage.setItem(key(playId), JSON.stringify(words));
  } catch {
    // Private mode or full storage: the stat just counts this session.
  }
}
